import React, { Component, createRef }  from "react";
import { Modal, Button, Form } from 'react-bootstrap';
import { userService } from '../services/user';
import { pinService } from '../services/pin';
import '../assets/styles/VerifyPhoneModal.scss';
import '../assets/styles/MainModal.scss';
import { Formik } from 'formik';
import * as yup from 'yup';
import Select, { components } from 'react-select';
import _ from 'lodash';
import ReactPinField from "react-pin-field";
import ReCAPTCHA from "react-google-recaptcha";

export class VerifyPhoneModal extends Component {

    constructor(props) {
        super(props);

        this._reCaptchaRef = createRef();
        this.formActions = createRef();

        this.state = {
            edit_phone: false,
            current_step: 1,
            current_country_code: global.constant.default_country_code,
            countries: global.constant.countries.map((country) => ({ label: `${country.name} (${country.dial_code})`, value: country.code, full: country })),
            verify: {
                phone_number: ""
            },
            disable_generate_pin_btn: false,
            invalid_pin: false,
            token: "",
            clone_verify:{}
        };

    }

    verifySchema = yup.object().shape({
        phone_number: yup.string().required().min(7).max(12).label('Mobile Phone')
    });

    get show() {
        return this.props.showVerifyPhoneModal;
    }

    onEditClick(){
        this.setState({
            edit_phone: true
        });
    }

    handleVerify(formData, actions, stateData){
        this.formActions = actions;
        let params = _.cloneDeep(formData);
        let selected_country = stateData.countries.find(option => option.value === stateData.current_country_code)
        params.phone_number = `${selected_country.full.dial_code.replace(/\D/g,'')}${params.phone_number}`;
        params.call_type = 'web';

        this.setState({
            clone_verify: params
        }, () => {
            this.state.token ? this.changeNumber() : this._reCaptchaRef.current.execute();
        })
    }

    changeNumber(){
        this.setState(prevState => ({
            clone_verify: {
                ...prevState.clone_verify,
                token: this.state.token
            }
        }), () => {
            userService.changeNumber(this.state.clone_verify)
            .then(
                response => {
                    this._reCaptchaRef.current.reset();
                    this.setState({
                        token: null
                    });
                    if(response.success || _.has(response,'auth_token')){
                        // generate pin
                        this.onNextClick();
                        this.updateLocalStorageNumber(this.state.clone_verify.phone_number);
                    }else{
                        if(_.has(response, 'errors')){
                            alert(response.errors[0])
                        }else{
                            this.formActions.setErrors({
                                phone_number: 'Phone number is already in use.'
                            });
                        }
                    }
    
                },
                error => {
                    this.setState({ error, loading: false })
                }
            );
        });
    }

    onNextClick(){
        this.generatePin();
    }

    generatePin(){
        pinService.generate().then(
            data => {
                if(_.has(data,'errors')){
                    alert(data.errors[0]);
                }else if(_.has(data,'error')){
                    alert(data.error);
                }else{
                    this.setState({
                        current_step: 2
                    });            
                    this.setState({
                        disable_generate_pin_btn: true
                    });
                    // **** here's the timeout ****
                    setTimeout(() => this.setState({ disable_generate_pin_btn: false }), 60000);
                }
            },
            error => {
                console.log('pin service here error')
                console.log(error)
            }
        );
    }

    closeVerifyModal(){
        this.setState({
            edit_phone: false,
            current_step: 1
        });
        this.props.handleVerifyPhoneModal(false);
    }

    verifyPin(pin){
        let params = {
            pin_number: pin
        }
        let isPinCorrect;
        pinService.verify(params).then(
            response => {
                isPinCorrect = response;
                this.setState({
                    invalid_pin: !isPinCorrect
                });

                let list = document.querySelectorAll('.pin-field')
                for (var i = 0; i < list.length; ++i) {
                    isPinCorrect ? list[i].classList.remove('incorrect-pin') : list[i].classList.add('incorrect-pin');
                }

                if(isPinCorrect){
                    // close modal
                    // open booking order
                    // change user data - verified to true

                    this.closeVerifyModal();
                    this.props.handleBookingModal(true);

                    let user = {
                        ...JSON.parse(localStorage.getItem('user')),
                        verified: true
                    };
                    localStorage.setItem('user', JSON.stringify(user));
                }
            },
            error => {
                this.setState({ error, loading: false })
            }
        );
    }

    handleTokenChange = value => {
        this.setState({ token: value });
        if (value === null){
            this.setState({ formErrors: ["Token expired. Please refresh the page and try again"] });
        }else{
            this.changeNumber();
        }
    };

    updateLocalStorageNumber = value => {
        let user = {
            ...JSON.parse(localStorage.getItem('user')),
            phone: value
        };
        localStorage.setItem('user', JSON.stringify(user));
    }

    render() {
        const SingleValue = country_props => (
            <components.SingleValue {...country_props}>
              {country_props.data.full.dial_code}
            </components.SingleValue>
        );
        return (
            <Modal show={this.show} backdrop="static" size="lg" dialogClassName="verify-phone-modal main-modal">
                <button className="btn close-modal-btn" onClick={() => this.closeVerifyModal()}>
                    <i className="fa fa-times"></i>
                </button>
                <Modal.Body>
                    <div className="title">Please Verify Your Phone Number</div>
                    {this.state.current_step === 2 &&
                        <div className="pin-step-container">
                            <ReactPinField length="4" className="pin-field" onComplete={(val) => this.verifyPin(val)}/>
                            <div className={`invalid-pin-error ${this.state.invalid_pin ? 'show' : ''}`}>Invalid Pin Number</div>
                            <Button className={`btn-block submit-btn ${this.state.disable_generate_pin_btn ? 'disabled' : ''}`} type="button" onClick={() => this.generatePin()}>Generate Pin</Button>
                        </div>
                    }
                    {this.state.current_step === 1 &&
                        (() => {
                            if (userService.getUser().phone && !this.state.edit_phone) {
                                return (
                                    <div className="verify-current-phone" show={this.state.current_step === 1}>
                                        <div className="phone-number">+{userService.getUser().phone}</div>
                                        <button className="btn btn-block next-btn" onClick={() => this.onNextClick()}>Next</button>
                                        <button className="btn btn-link" onClick={() => this.onEditClick()}>Edit</button>
                                    </div>
                                );
                            } else {
                                return <Formik show={this.state.current_step === 1} validationSchema={this.verifySchema} onSubmit={(form, actions) => this.handleVerify(form, actions, this.state)} initialValues={this.state.verify}>
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit} className="verify-form">
                                        <Form.Row>
                                            <Form.Group className="phone-field-div">
                                                <Select className="phone-prefix-field" value={this.state.countries.filter(option => option.value === this.state.current_country_code)} options={this.state.countries} onChange={selected => this.setState({ current_country_code: selected.value })} components={{ SingleValue }}/>
                                                <div className="phone-input-div">
                                                    <Form.Control
                                                        type="text"
                                                        name="phone_number"
                                                        value={values.phone_number}
                                                        onChange={handleChange}
                                                        isValid={touched.phone && !errors.phone_number}
                                                        isInvalid={!!errors.phone_number}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.phone_number}
                                                    </Form.Control.Feedback>
                                                </div>
                                            </Form.Group>
                                            <ReCAPTCHA
                                            ref={this._reCaptchaRef}
                                            sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}
                                            size="invisible"
                                            onChange={this.handleTokenChange}
                                            badge="bottomleft"
                                            />
                                        </Form.Row>

                                        <Button className="btn-block submit-btn" type="submit">Next</Button>
                                    </Form>
                                )}
                                </Formik>;
                            }
                        })()
                    }

                </Modal.Body>
            </Modal>
        );
  }
}